module.exports = __webpack_public_path__ + "static/media/ventilator-air-cleaner.f92ec656.jpg";